/** File terminology:
 *  - Tab: Any root-level <li> element within the navigation list.
 *  - Sub menu: Any <li> element within tabs that has a 'menu-item-has-children' class.
 */
(function () {
    const navigationList = document.querySelector('.navigation__list');

    if (navigationList === null) {
        return;
    }

    const MENU_ITEM_ACTIVE = 'menu-item-active';
    const SUB_MENU_ACTIVE = 'sub-menu-active';
    const MENU_ITEM_HAS_CHILDREN = '.menu-item-has-children';
    const tabs = navigationList.querySelectorAll(':scope > li');

    const ensureSingleTabIsActive = (activeTabId) => {
        // Remove the active class from any tab that isn't the currently selected tab.
        tabs.forEach(tab => {
            if (tab.id !== activeTabId) {
                tab.classList.remove(MENU_ITEM_ACTIVE);
            }
        });

        // tabs.forEach(tab => tab.id !== activeTabId && tab.classList.remove(MENU_ITEM_ACTIVE));
    };

    const ensureSingleSubMenuIsActive = (activeMenuId) => {
        // Remove the active class from any sub menu that isn't the currently selected sub menu.
        tabs.forEach(tab => {
            tab.querySelectorAll(MENU_ITEM_HAS_CHILDREN).forEach(menuItem => {
                if (menuItem.id !== activeMenuId) {
                    menuItem.querySelector('.sub-menu').classList.remove(SUB_MENU_ACTIVE);
                }
            });
        });
    };

    const addKeyEventListenerToTab = (tab, index) => {
        tab.querySelector('a').addEventListener('keydown', (e) => onTabKeyDown(e, index));
    };

    const addFocusEventsToSubMenu = (tab) => {
        // Find any element within the current that that contains children.
        const subMenus = tab.querySelectorAll('.menu-item');
        if (subMenus.length === 0) {
            return;
        }

        // Add a focus eventListener to assign active states to sub menus.
        subMenus.forEach(subMenu => subMenu.querySelector('a').addEventListener('focus', (e) => onSubMenuFocus(e)));
    };

    const onTabKeyDown = (event, index) => {
        if (event.keyCode !== 13) {
            return;
        }
        event.preventDefault();

        const currentTab = tabs[index];

        currentTab.classList.toggle(MENU_ITEM_ACTIVE);

        ensureSingleTabIsActive(currentTab.id);


        tabs.forEach(tab => tab.querySelector('.sub-menu').classList.remove(SUB_MENU_ACTIVE));
    };

    const onSubMenuFocus = (event) => {
        const subMenu = event.target.closest(MENU_ITEM_HAS_CHILDREN).querySelector('.sub-menu');
        subMenu.classList.add(SUB_MENU_ACTIVE);

        ensureSingleSubMenuIsActive(subMenu.closest('.menu-item').id);
    };

    tabs.forEach((tab, index) => {
        addKeyEventListenerToTab(tab, index);
        addFocusEventsToSubMenu(tab);
    });
}());


// WEBPACK FOOTER //
// ./scripts/custom/navigation.js